import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const BulletPointList = styled.ul`
  list-style: disc;
`

export const BulletPoint = styled.li`
  margin-bottom: ${Spacing.S6};
  margin-left: ${Spacing.S16};
`
